import api from './api';
import jwtDecode from 'jwt-decode';

// Login user
export const login = async (credentials) => {
    const response = await api.post('/auth/login', credentials);

    // Store token and user data in localStorage
    if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data));
    }

    return response.data;
};

// Register user (Super Admin only)
export const register = async (userData) => {
    const response = await api.post('/auth/register', userData);
    return response.data;
};

// Logout user
export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
};

// Get current user data
export const getCurrentUser = () => {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;

    try {
        return JSON.parse(userStr);
    } catch (error) {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        return null;
    }
};

// Check if token is expired
export const isTokenExpired = () => {
    const token = localStorage.getItem('token');
    if (!token) return true;

    try {
        const decoded = jwtDecode(token);
        return decoded.exp < Date.now() / 1000;
    } catch (error) {
        return true;
    }
};

// Check if user is authenticated
export const isAuthenticated = () => {
    const token = localStorage.getItem('token');
    return !!token && !isTokenExpired();
};

// Get current user profile from API
export const getProfile = async () => {
    const response = await api.get('/auth/me');
    return response.data;
};

// Check if user has required role
export const hasRole = (role) => {
    const user = getCurrentUser();
    if (!user) return false;

    if (Array.isArray(role)) {
        return role.includes(user.role);
    }

    return user.role === role;
};